import './list.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const List = forwardRef((props, ref) => {
  const className = classNames({
    list: true,
    'list-styled': props.styled,
    [props.className]: props.className,
  });

  const Component = props.ordered ? 'ol' : 'ul';

  return (
    <Component ref={ref} className={className}>
      {props.children}
    </Component>
  );
});

List.propTypes = {
  ordered: PropTypes.bool,
  styled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

List.defaultProps = {
  ordered: false,
  styled: false,
};

const Item = forwardRef((props, ref) => {
  const className = classNames({
    'list-item': true,
    [props.className]: props.className,
  });

  return (
    <li ref={ref} className={className} onMouseEnter={props.onHover}>
      {props.children}
    </li>
  );
});

Item.propTypes = {
  className: PropTypes.string,
  onHover: PropTypes.func,
  children: PropTypes.node,
};

List.Item = Item;

export default List;
